import React from "react";
import Trial from "../../sections/Bookfreetrial/Trial";
import Footer from "../../sections/Footer/Footer";
import Header from "../../sections/Header/Header";
import PricingCards from "../../sections/PricingCards/PricingCards";
import TitlepicPricing from "../../sections/TitlepicPricing/TitlepicPricing";

const Pricing = ()=>{
    return(
        <div>
            
            <Header/>
            <TitlepicPricing/>
            <PricingCards/>
            <Trial/>
            <Footer/>
        </div>
    )
}
export default Pricing;
